import { useMemo } from 'react';

import { type CheckboxOptionProps } from '@innovationnorway/component-library';
import { useTranslation } from 'react-i18next';
import { DeliveryType } from 'src/api/v2';

const useDeliveryTypeOptions = (selectedDeliveryTypes?: string[]) => {
  const { t } = useTranslation('oneWayIn');
  const deliveryTypeOptions: CheckboxOptionProps[] = useMemo(
    () => [
      {
        text: t(`deliveryType.${DeliveryType.Lavrisikolaan}`),
        value: DeliveryType.Lavrisikolaan,
        selected: selectedDeliveryTypes?.includes(DeliveryType.Lavrisikolaan) ?? false,
      },
      {
        text: t(`deliveryType.${DeliveryType.Risikolaan}`),
        value: DeliveryType.Risikolaan,
        selected: selectedDeliveryTypes?.includes(DeliveryType.Risikolaan) ?? false,
      },
      {
        text: t(`deliveryType.${DeliveryType.Egenkapital}`),
        value: DeliveryType.Egenkapital,
        selected: selectedDeliveryTypes?.includes(DeliveryType.Egenkapital) ?? false,
      },
      {
        text: t(`deliveryType.${DeliveryType.Garantier}`),
        value: DeliveryType.Garantier,
        selected: selectedDeliveryTypes?.includes(DeliveryType.Garantier) ?? false,
      },
      {
        text: t(`deliveryType.${DeliveryType.Tilskudd}`),
        value: DeliveryType.Tilskudd,
        selected: selectedDeliveryTypes?.includes(DeliveryType.Tilskudd) ?? false,
      },
      {
        text: t(`deliveryType.${DeliveryType.Foredrag}`),
        value: DeliveryType.Foredrag,
        selected: selectedDeliveryTypes?.includes(DeliveryType.Foredrag) ?? false,
      },
      {
        text: t(`deliveryType.${DeliveryType.Kurs}`),
        value: DeliveryType.Kurs,
        selected: selectedDeliveryTypes?.includes(DeliveryType.Kurs) ?? false,
      },
      {
        text: t(`deliveryType.${DeliveryType.Raadgivning}`),
        value: DeliveryType.Raadgivning,
        selected: selectedDeliveryTypes?.includes(DeliveryType.Raadgivning) ?? false,
      },
      {
        text: t(`deliveryType.${DeliveryType.Connecting}`),
        value: DeliveryType.Connecting,
        selected: selectedDeliveryTypes?.includes(DeliveryType.Connecting) ?? false,
      },
      {
        text: t(`deliveryType.${DeliveryType.Fellesarrangementer}`),
        value: DeliveryType.Fellesarrangementer,
        selected: selectedDeliveryTypes?.includes(DeliveryType.Fellesarrangementer) ?? false,
      },
      {
        text: t(`deliveryType.${DeliveryType.Orientering}`),
        value: DeliveryType.Orientering,
        selected: selectedDeliveryTypes?.includes(DeliveryType.Orientering) ?? false,
      },
      {
        text: t(`deliveryType.${DeliveryType.Prosjektarbeid}`),
        value: DeliveryType.Prosjektarbeid,
        selected: selectedDeliveryTypes?.includes(DeliveryType.Prosjektarbeid) ?? false,
      },
      {
        text: t(`deliveryType.${DeliveryType.Publikasjon}`),
        value: DeliveryType.Publikasjon,
        selected: selectedDeliveryTypes?.includes(DeliveryType.Publikasjon) ?? false,
      },
      {
        text: t(`deliveryType.${DeliveryType.Selvbetjening}`),
        value: DeliveryType.Selvbetjening,
        selected: selectedDeliveryTypes?.includes(DeliveryType.Selvbetjening) ?? false,
      },
    ],
    [selectedDeliveryTypes, t],
  );

  return { deliveryTypeOptions };
};

export default useDeliveryTypeOptions;
